import { Navigate } from "react-router-dom";
import { useSession } from "../../lib/session";

export default function DashboardSetup(): JSX.Element {
  const user = useSession((s) => s.user);
  const loading = useSession((s) => s.loading);
  if (loading) return <div className="card">Loading…</div>;
  if (!user) return <Navigate to="/login?returnUrl=/dashboard/setup" replace />;
  return (
    <>
      <h1>Setup</h1>
      <div className="card stack">
        <h2 style={{ marginTop: 0 }}>1. Connect your channel</h2>
        <p>Twitch or YouTube — link the account you stream on.</p>
        <h2>2. Create factions</h2>
        <p>Two or more teams donors can rally behind. Pick names and colors.</p>
        <h2>3. Add the overlay to OBS</h2>
        <p>Browser source pointing at your unique overlay URL (see the Overlay tab).</p>
      </div>
    </>
  );
}
